angular.module('bribac.components.moodQuestion', [
  'bribac.translations'
])

  .component('moodQuestion', {
    templateUrl: 'mood-question-component.html',
    controller: 'moodQuestionCtrl',
    bindings: {
      moodQuestion: '<',
      editCallback: '<',
      deleteCallback: '<',
      index: '<'
    }
  }).controller('moodQuestionCtrl', function () {
    var $ctrl = this
  });
